import { useQuery } from "@tanstack/react-query";
import { contentApi } from "@/lib/api";
import { citiesFallback, reviewsFallback, servicePriceOverrides, servicesFallback } from "@/data/content";

export function useContent() {
  const services = useQuery({ queryKey: ["services"], queryFn: contentApi.services, placeholderData: servicesFallback });
  const cities = useQuery({ queryKey: ["cities"], queryFn: contentApi.cities, placeholderData: citiesFallback });
  const reviews = useQuery({ queryKey: ["reviews"], queryFn: contentApi.reviews, placeholderData: reviewsFallback });
  const localizedServices = (services.data || servicesFallback).map(service => ({ ...service, price: servicePriceOverrides[service.slug] || service.price }));
  return { services: localizedServices, cities: cities.data || citiesFallback, reviews: reviews.data || reviewsFallback };
}